import { useCallback, useState } from 'react';
export const useBoolState = (options = {}) => {
    const { callbackChangeFalse = null, callbackChangeTrue = null, initialState = false, } = options;
    const [boolState, changeBoolState] = useState(initialState);
    const changeTrue = useCallback(() => {
        if (callbackChangeTrue) {
            callbackChangeTrue();
        }
        changeBoolState(true);
    }, [callbackChangeTrue, changeBoolState]);
    const changeFalse = useCallback(() => {
        if (callbackChangeFalse) {
            callbackChangeFalse();
        }
        changeBoolState(false);
    }, [callbackChangeFalse, changeBoolState]);
    const changeToggle = useCallback(() => {
        changeBoolState((prev) => !prev);
    }, [changeBoolState]);
    return {
        boolState,
        changeFalse,
        changeToggle,
        changeTrue,
    };
};
